<span [class]="badgeClasses()">
  {{ label() }}
</span>